<section class="reset-password-section">
  <div class="reset-password-wrapper">
    <!-- Header -->
    <div class="header-container text-center">
      <div class="logo-wrapper">
        <img [src]="brandLogo" alt="Crizac" title="Crizac" class="logo-img" />
      </div>
      <h2 class="title">Reset Password</h2>
      <p class="subtitle">Your new password must be different from previously used passwords.</p>
    </div>

    <!-- White Card -->
    <div class="form-card">
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onSubmit()">
        <!-- New Password -->
        <div class="form-group">
          <label for="newPassword">
            New Password <span class="required">*</span>
          </label>
          <mat-form-field appearance="fill" class="full-width custom-form-field">
            <input matInput [type]="hideNewPassword ? 'password' : 'text'" placeholder="Enter your new password"
              formControlName="newPassword" id="newPassword" />
            <button mat-icon-button matSuffix type="button" (click)="hideNewPassword = !hideNewPassword"
              [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hideNewPassword" class="eye-btn">
              <mat-icon>{{ hideNewPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <div class="error-container"
            *ngIf="resetPasswordForm.get('newPassword')?.touched && resetPasswordForm.get('newPassword')?.invalid">
            <div class="error-msg" *ngIf="resetPasswordForm.get('newPassword')?.hasError('required')">
              <mat-icon fontIcon="error_outline"></mat-icon> Password is required
            </div>
            <div class="error-msg" *ngIf="resetPasswordForm.get('newPassword')?.hasError('minlength')">
              <mat-icon fontIcon="error_outline"></mat-icon> Minimum 8 characters required
            </div>
            <div class="error-msg" *ngIf="resetPasswordForm.get('newPassword')?.hasError('maxlength')">
              <mat-icon fontIcon="error_outline"></mat-icon> Maximum 20 characters allowed
            </div>
            <div class="error-msg" *ngIf="resetPasswordForm.get('newPassword')?.hasError('pattern')">
              <mat-icon fontIcon="error_outline"></mat-icon> One uppercase and one special character is required
            </div>
          </div>
        </div>

        <!-- Confirm Password -->
        <div class="form-group mt-3">
          <label for="confirmPassword">
            Confirm Password <span class="required">*</span>
          </label>
          <mat-form-field appearance="fill" class="full-width custom-form-field">
            <input matInput [type]="hideConfirmPassword ? 'password' : 'text'" placeholder="Confirm your new password"
              formControlName="confirmPassword" id="confirmPassword" />
            <button mat-icon-button matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword"
              [attr.aria-label]="'Hide confirm password'" [attr.aria-pressed]="hideConfirmPassword" class="eye-btn">
              <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </mat-form-field>
          <div class="error-container"
            *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.get('confirmPassword')?.invalid">
            <div class="error-msg" *ngIf="resetPasswordForm.get('confirmPassword')?.hasError('required')">
              <mat-icon fontIcon="error_outline"></mat-icon> Confirm password is required
            </div>
          </div>
          <div class="error-container"
            *ngIf="resetPasswordForm.get('confirmPassword')?.touched && resetPasswordForm.hasError('mismatch')">
            <div class="error-msg">
              <mat-icon fontIcon="error_outline"></mat-icon> Passwords do not match
            </div>
          </div>
        </div>

        <!-- Alert messages -->
        <div class="alert alert-danger mt-3" *ngIf="errorMessage">
          <mat-icon fontIcon="error"></mat-icon>
          <span>{{ errorMessage }}</span>
        </div>
        <div class="alert alert-success mt-3" *ngIf="successMessage">
          <mat-icon fontIcon="check_circle"></mat-icon>
          <span>{{ successMessage }}</span>
        </div>

        <!-- Submit Button -->
        <button class="full-width submit-btn mt-4" mat-raised-button type="submit"
          [disabled]="resetPasswordForm.invalid || isLoading" [class.loading]="isLoading">
          <span *ngIf="!isLoading">Set New Password</span>
          <span *ngIf="isLoading" class="loader"></span>
        </button>
      </form>
    </div>

    <!-- Back to Login -->
    <div class="back-link">
      <a routerLink="/login" class="back-link-anchor">
        <mat-icon fontIcon="arrow_back"></mat-icon>
        <span>Back to Login</span>
      </a>
    </div>
  </div>
</section>